<template>
  <div class="home">
    <BerandaView />
    <AboutView />
    <ServiceView/>
    <ClientView/>
    <TechnologyView/>
    <FaqView/>
    <NewsView/>
    <SdgsView/>
    <KarirView/>
    <ContactView/>
  </div>
</template>

<script>
import BerandaView from './views/Beranda/BerandaView.vue';
import AboutView from './views/About/AboutView.vue';
import ServiceView from './views/Service/ServiceView.vue';
import ClientView from './views/Client/ClientView.vue';
import FaqView from './views/FAQ/FaqView.vue';
import ContactView from './views/Contact/ContactView.vue';
import SdgsView from './views/Sdgs/SdgsView.vue';
import TechnologyView from './views/Technology/TechnologyView.vue';
import NewsView from './views/News/NewsView.vue';
import KarirView from './views/Karir/KarirView.vue';
export default {
  name: 'HomeView',
  components: {
    BerandaView,
    AboutView,
    ServiceView,
    ClientView,
    FaqView,
    ContactView,
    SdgsView,
    TechnologyView,
    NewsView,
    KarirView
  }
}
</script>
